/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Service_ScheduledInputs */

const en_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a Session`)
};

const es_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar una sesión`)
};

const fr_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réserver une session`)
};

const de_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzung buchen`)
};

const ja_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションの予約`)
};

const zh_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约服务`)
};

const ar_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجز جلسة`)
};

const id_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Sesi`)
};

const it_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una Sessione`)
};

const ru_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забронировать сеанс`)
};

const pt_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendar uma Sessão`)
};

const ko_fulfillment_service_scheduled = /** @type {(inputs: Fulfillment_Service_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세션 예약`)
};

/**
* | output |
* | --- |
* | "Book a Session" |
*
* @param {Fulfillment_Service_ScheduledInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_service_scheduled = /** @type {((inputs?: Fulfillment_Service_ScheduledInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Service_ScheduledInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_service_scheduled(inputs)
	if (locale === "es") return es_fulfillment_service_scheduled(inputs)
	if (locale === "fr") return fr_fulfillment_service_scheduled(inputs)
	if (locale === "de") return de_fulfillment_service_scheduled(inputs)
	if (locale === "ja") return ja_fulfillment_service_scheduled(inputs)
	if (locale === "zh") return zh_fulfillment_service_scheduled(inputs)
	if (locale === "ar") return ar_fulfillment_service_scheduled(inputs)
	if (locale === "id") return id_fulfillment_service_scheduled(inputs)
	if (locale === "it") return it_fulfillment_service_scheduled(inputs)
	if (locale === "ru") return ru_fulfillment_service_scheduled(inputs)
	if (locale === "pt") return pt_fulfillment_service_scheduled(inputs)
	return ko_fulfillment_service_scheduled(inputs)
});